interface ChartEmptyStateProps {
  message?: string;
}

export function ChartEmptyState({ message = 'No data for this period yet.' }: ChartEmptyStateProps) {
  return (
    <div className="flex items-center justify-center h-48 text-sm text-muted-foreground">
      {message}
    </div>
  );
}
